var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { PureComponent } from "react";
import Hr from "@irati/ui/src/Layout/Hr";
import Flex from "@irati/ui/src/Flex";
import OptionTab from "./OptionTab";
import LoseChangesModal from "./LoseChangesModal";
var OptionPicker = /** @class */ (function (_super) {
    __extends(OptionPicker, _super);
    function OptionPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showOptions: true,
            selectedOptionId: _this.props.existingSelectionId === 0 ? undefined : _this.props.existingSelectionId
        };
        _this.getTabContent = function (selectionId) {
            var _a = _this.props, setIsStepCompletable = _a.setIsStepCompletable, options = _a.options;
            var selectedOption = options.find(function (option) { return option.selectionId === selectionId; });
            if (!selectedOption)
                return null;
            var newProps = {
                setIsStepCompletable: setIsStepCompletable,
                setOptionsVisibility: _this.setOptionsVisibility
            };
            return React.cloneElement(selectedOption.component, newProps);
        };
        _this.handleTabClick = function (option) {
            if (_this.state.selectedOptionId === option.selectionId)
                return;
            // Check for changes to be reverted based on step + "has anything been changed?"
            // If yes, show modal to alert that we're going to revert the changes
            // shouldResetToDefault and resetToDefault are shared function call, the implementation itself depends on the step
            var areStepSettingsDefault = _this.props.areStepSettingsDefault;
            if (!areStepSettingsDefault || !_this.state.selectedOptionId) {
                _this.selectOption(option);
            }
            else {
                areStepSettingsDefault().then(function (isDefault) {
                    if (isDefault) {
                        _this.selectOption(option);
                    }
                    else {
                        _this.showModal(option);
                    }
                });
            }
        };
        _this.setOptionsVisibility = function (showOptions) {
            _this.setState({ showOptions: showOptions });
        };
        _this.handleReset = function () {
            // @ts-ignore
            var load = _this.props.resetToDefault().then(function () {
                _this.selectOption(_this.state.optionToBeSelected);
                _this.hideModal();
            });
            _this.setState({ load: load });
        };
        _this.selectOption = function (option) {
            _this.setState({ selectedOptionId: option.selectionId });
            _this.props.handleOptionChange(option);
        };
        _this.showModal = function (option) {
            _this.setState({
                optionToBeSelected: option,
                showPrompt: true
            });
        };
        _this.hideModal = function () {
            _this.setState({
                optionToBeSelected: undefined,
                showPrompt: false
            });
        };
        return _this;
    }
    OptionPicker.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, existingSelectionId, areStepSettingsDefault, setIsStepCompletable, options, selectedOption, isDefault, completable;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, existingSelectionId = _a.existingSelectionId, areStepSettingsDefault = _a.areStepSettingsDefault, setIsStepCompletable = _a.setIsStepCompletable, options = _a.options;
                        // If there are no options that have required actions step can be instantly completed
                        if (!options.find(function (option) { return option.actionRequiredForStepCompletion; })) {
                            return [2 /*return*/, setIsStepCompletable(true)];
                        }
                        if (!(existingSelectionId && areStepSettingsDefault)) return [3 /*break*/, 2];
                        selectedOption = options.find(function (option) { return option.selectionId === existingSelectionId; });
                        return [4 /*yield*/, areStepSettingsDefault()
                            // ensure the option selected meets requirements to mark as complete
                        ];
                    case 1:
                        isDefault = _b.sent();
                        completable = (selectedOption.actionRequiredForStepCompletion && !isDefault) || !selectedOption.actionRequiredForStepCompletion;
                        setIsStepCompletable(completable);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    OptionPicker.prototype.render = function () {
        var _this = this;
        var options = this.props.options;
        var _a = this.state, showOptions = _a.showOptions, selectedOptionId = _a.selectedOptionId, showPrompt = _a.showPrompt, load = _a.load;
        return (React.createElement(React.Fragment, null,
            showOptions && (React.createElement(Flex, { justifyContent: "space-between" }, options.map(function (option) { return (React.createElement(OptionTab, __assign({ key: "OptionTab" + option.selectionId + "-" + option.title, selected: selectedOptionId === option.selectionId }, option, { handleClick: function () { return _this.handleTabClick(option); } }))); }))),
            showOptions && selectedOptionId && React.createElement(Hr, null),
            selectedOptionId && this.getTabContent(selectedOptionId),
            React.createElement(LoseChangesModal, { load: load, handleReset: this.handleReset, onHide: this.hideModal, show: showPrompt })));
    };
    return OptionPicker;
}(PureComponent));
export default OptionPicker;
